<template>
  <div style="padding-bottom: 120px;" v-if="readyToEdit">
    <div class="px-4">
      <v-row>
        <v-col cols="12" xs="12" md="12">
          <div class="d-flex align-center mb-8">
            <v-card elevation="1" class="mr-4 pa-3 d-flex align-center justify-center" width="128" height="128">
              <v-img contain :src="selectedStore.logo"></v-img>
            </v-card>
  
            <div class="d-flex flex-column">
              <h1 class="display-5">
                {{ selectedStore.name }}
                <v-chip v-if="this.selectedStore.master == true" small class="font-weight-bold white--text" color="green"
                  label>Master</v-chip>
              </h1>
              <v-breadcrumbs style="padding: 0px">https://{{ selectedStore.url }}.themediatrade.com/
                <v-btn icon :href="`https://${selectedStore.url}.themediatrade.com/`"
                  target="blank"><v-icon>mdi-open-in-new</v-icon></v-btn>
              </v-breadcrumbs>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-divider></v-divider>
    <template>
      <v-tabs color="primary" v-model="tabs" background-color="#f4f4f4">
        <template v-for="(item, i) in menuBar">
          <v-tab :class="i == 0 ? `ml-4` : ``" :disabled="!item.enabled" :key="`t-${item.title}`">
            <span>{{ item.title }}</span>
          </v-tab>
          <v-chip :key="`c-${item.title}`" x-small class="mb-2 mt-2 px-1 ml-n3" color="info" v-if="!item.enabled"><span
              class="black---text">{{
                $t("mainStore.underDev")
              }}</span></v-chip>
        </template>
      </v-tabs>
    </template>
    <v-divider></v-divider>
    <v-row class="px-4">
      <v-col cols="12" md="12">
        <template>
          <v-card color="" elevation="0" class="" v-if="formStore && formStore.info && formStore.info.audience">
            <v-tabs-items v-model="tabs">
              <v-tab-item>
                <v-card flat outlined class="mt-8 px-6">
                  <StoreNameVue :store-name="formStore.name" @update:storeName="updateStoreName" />

                  <v-divider></v-divider>

                  <!-- LOGO SECTION -->
                  <v-row class="py-3">
                    <v-col class="d-flex align-center" cols="12" md="6">
                      <v-card-subtitle class="title px-0">{{
                        $t("mainStore.aboutStore.storeLogo")
                      }}</v-card-subtitle>
                    </v-col>
                    <v-col class="d-flex align-end justify-end" cols="12" md="6">
                      <v-card elevation="0" class="d-flex flex-column mx-n2">
                        <Upload :path="'/store/logo/'" @change-url="formStore.logo = $event" :snap="formStore.logo"
                          mime="image/jpeg,image/png">
                        </Upload>
                      </v-card>
                    </v-col>
                  </v-row>


                  <v-divider></v-divider>

                  <SwitchEditor :title="$t('mainStore.status.title')" :subtitle="statusFormText"
                    :active-text="$t('allStores.activeStore')" :update-snap="confirm.update" :inactive-text="$t('allStores.inactiveStore')
                      " :snap="statusForm" @update-form="
    saveStatus($event)
    "></SwitchEditor>
                  <v-divider></v-divider>


                  <SwitchEditor :title="$t('mainStore.restrictAccessToWhitelist.title')"
                    :subtitle="$t('mainStore.restrictAccessToWhitelist.subtitle')"
                    :active-text="$t('mainStore.restrictAccessToWhitelist.allow')" :inactive-text="$t('mainStore.restrictAccessToWhitelist.disallow')
                      " :snap="formStore.options.restrictAccessToWhitelist" :reverse-value="false" @update-form="
    formStore.options.restrictAccessToWhitelist = $event
    "></SwitchEditor>

                  <v-row class="pt-0 pb-5" v-if="formStore.options.restrictAccessToWhitelist">
                    <v-col class="d-flex align-center py-0" cols="12" md="12">
                      <v-card-subtitle class="title px-0 py-0">{{
                        $t("mainStore.restrictAccessToWhitelist.descriptionTitle")
                      }}</v-card-subtitle>
                    </v-col>
                    <v-col class="d-flex py-0" cols="12" md="6">
                      <h5 class="grey--text">{{
                        $t("mainStore.restrictAccessToWhitelist.descriptionSubtitle")
                      }}</h5>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                      <v-tiptap v-model="formStore.options.restrictAccessText" :toolbar='[
                        "bold",
                        "italic",
                        "underline",
                        "color",
                        "|",
                        "headings",
                        "|",
                        "left",
                        "center",
                        "right",
                        "justify",
                        "|",
                        "bulletList",
                        "orderedList",
                        "|",
                        "link",
                        "emoji",
                        "|",
                        "clear",
                      ]' />
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>


                  <!--  class="grey darken-2" -->

                  <SwitchEditor :title="$t('mainStore.langView.title')" :subtitle="$t('mainStore.langView.subtitle')"
                    :active-text="$t('mainStore.langView.allow')" :inactive-text="$t('mainStore.langView.disallow')
                      " :snap="formStore.options.hideOthersLang" :reverse-value="true" @update-form="
    formStore.options.hideOthersLang = $event
    "></SwitchEditor>
                  <v-divider></v-divider>
                  <StoreURLVue @update:storeURL="updateStoreURL" :store-u-r-l="formStore.redirectURL" />

                  <v-divider></v-divider>
                  <!-- <PriceView
                    v-if="
                      formStore.options &&
                      (formStore.options.priceView === true ||
                        formStore.options.priceView === false)
                    "
                    @update:price-view="updatePriceView($event)"
                    :price-view="formStore.options.priceView"
                  />

                  <v-divider></v-divider> -->



                  <SwitchEditor :title="$t('mainStore.aboutStore.priceView.title')"
                    :subtitle="$t('mainStore.aboutStore.priceView.subtitle')"
                    :active-text="$t('mainStore.aboutStore.priceView.allow')" :inactive-text="$t('mainStore.aboutStore.priceView.disallow')
                      " :snap="formStore.options.priceView" @update-form="
    formStore.options.priceView = $event
    "></SwitchEditor>
                  <v-divider></v-divider>

                  <SwitchEditor :title="$t('mainStore.aboutInHome.title')"
                    :subtitle="$t('mainStore.aboutInHome.subtitle')" :active-text="$t('mainStore.aboutInHome.allow')"
                    :inactive-text="$t('mainStore.aboutInHome.disallow')
                      " :snap="formStore.options.aboutInHome" @update-form="
    formStore.options.aboutInHome = $event
    "></SwitchEditor>
                  <v-divider></v-divider>


                  <SwitchEditor :title="$t('mainStore.includeTax.title')" :subtitle="$t('mainStore.includeTax.subtitle')"
                    :active-text="$t('mainStore.includeTax.allow')" :inactive-text="$t('mainStore.includeTax.disallow')
                      " :snap="formStore.options.includeTax" @update-form="
    formStore.options.includeTax = $event
    "></SwitchEditor>
                  <v-divider></v-divider>


                  <SwitchEditor :title="$t('mainStore.asusView.title')" :subtitle="$t('mainStore.asusView.subtitle')"
                    :active-text="$t('mainStore.asusView.allow')" :inactive-text="$t('mainStore.asusView.disallow')
                      " :snap="formStore.options.hideAsus" :reverse-value="true" @update-form=" 
    formStore.options.hideAsus = $event
    "></SwitchEditor>

                  <v-divider></v-divider>

                  <SwitchEditor :title="$t('mainStore.noContent.title')" :subtitle="$t('mainStore.noContent.subtitle')"
                    :active-text="$t('mainStore.contentBeforePayment.allow')" :inactive-text="$t('mainStore.contentBeforePayment.disallow')
                      " :snap="formStore.options.noContent" :reverse-value="true" @update-form="
    formStore.options.noContent = $event
    "></SwitchEditor>

                  <v-divider v-if="!formStore.options.noContent"></v-divider>

                  <SwitchEditor v-if="!formStore.options.noContent" :title="$t('mainStore.contentBeforePayment.title')"
                    :subtitle="$t('mainStore.contentBeforePayment.subtitle')"
                    :active-text="$t('mainStore.contentBeforePayment.allow')" :inactive-text="$t('mainStore.contentBeforePayment.disallow')
                      " :snap="formStore.options.contentBeforePayment" :reverse-value="false" @update-form="
    formStore.options.contentBeforePayment = $event
    "></SwitchEditor>

                  <v-divider></v-divider>



                  <SwitchEditor :title="$t('mainStore.hidePlacementHelper.title')"
                    :subtitle="$t('mainStore.hidePlacementHelper.subtitle')"
                    :active-text="$t('mainStore.contentBeforePayment.allow')" :inactive-text="$t('mainStore.contentBeforePayment.disallow')
                      " :snap="formStore.options.hidePlacementHelper" :reverse-value="true" @update-form="
    formStore.options.hidePlacementHelper = $event
    "></SwitchEditor>




                  <v-divider></v-divider>


                  <SwitchEditor :title="$t('mainStore.packagesView.title')"
                    :subtitle="$t('mainStore.packagesView.subtitle')" :active-text="$t('mainStore.packagesView.allow')"
                    :inactive-text="$t('mainStore.packagesView.disallow')
                      " :snap="formStore.options.hidePackages" :reverse-value="true" @update-form="
    formStore.options.hidePackages = $event
    "></SwitchEditor>

                  <v-divider></v-divider>


                  <SwitchEditor :title="$t('mainStore.packagesCpm.title')" v-if="formStore.options.hidePackages == false"
                    :subtitle="$t('mainStore.packagesCpm.subtitle')" :active-text="$t('mainStore.packagesCpm.allow')"
                    :inactive-text="$t('mainStore.packagesCpm.disallow')
                      " :snap="formStore.options.hidePackagesCPM" :reverse-value="true" @update-form="
    formStore.options.hidePackagesCPM = $event
    "></SwitchEditor>
                  <v-divider v-if="formStore.options.hidePackages == false"></v-divider>

                  <SwitchEditor :title="$t('mainStore.hideLocations.title')"
                    :subtitle="$t('mainStore.hideLocations.subtitle')" :active-text="$t('mainStore.hideLocations.allow')"
                    :inactive-text="$t('mainStore.hideLocations.disallow')
                      " :snap="formStore.options.hideLocations" :reverse-value="true" @update-form="
    formStore.options.hideLocations = $event
    "></SwitchEditor>
                  <v-divider></v-divider>
                  <SwitchEditor :title="$t('mainStore.hideCoverage.title')"
                    :subtitle="$t('mainStore.hideCoverage.subtitle')" :active-text="$t('mainStore.hideCoverage.allow')"
                    :inactive-text="$t('mainStore.hideCoverage.disallow')
                      " :snap="formStore.options.hideCoverage" :reverse-value="true" @update-form="
    formStore.options.hideCoverage = $event
    "></SwitchEditor>
                  <v-divider></v-divider>

                  <SwitchEditor :active-edit="true" :wip="true" :title="$t('mainStore.packageNeedQuotation.title')"
                    :subtitle="$t('mainStore.packageNeedQuotation.subtitle')"
                    :active-text="$t('mainStore.packagesView.allow')" :inactive-text="$t('mainStore.packagesView.disallow')
                      " :snap="formStore.options.packageNeedQuotation" :reverse-value="false" @update-form="
    formStore.options.packageNeedQuotation = $event
    "></SwitchEditor>

 <v-divider></v-divider>

                  <SwitchEditor title="Slides da Home" subtitle="Você pode mantê-los na largura do conteúdo ou na largura da tela"
                  active-text="Largura da tela" inactive-text="Largura do conteúdo (padrão)" :snap="formStore.options.slidesFullWidth" @update-form="
  formStore.options.slidesFullWidth = $event
  "></SwitchEditor>                  

<v-divider></v-divider>

                  <SwitchEditor :title="$t('mainStore.homeSessions.title')" :subtitle="$t('mainStore.homeSessions.subtitle')"
                  :active-text="$t('mainStore.homeSessions.allow')" :inactive-text="$t('mainStore.homeSessions.disallow')
                    " :snap="formStore.options.homeSessions" @update-form="
  formStore.options.homeSessions = $event
  "></SwitchEditor>
                <v-divider></v-divider>
             

                  <v-row class="py-3">
                    <v-col class="d-flex align-center" cols="12" md="6">
                      <div class="d-flex flex-column">
                       
                        <v-card-subtitle class="title py-0 px-0">
                         Regras para clientes reservados</v-card-subtitle>
                        <h5 class="grey--text">Qual ação tomar quando um cliente reservado se cadastrar</h5>
                      </div>
                    </v-col>
                    <v-col class="d-flex align-center justify-end" cols="12" md="6">
                      <v-select v-model="formStore.options.useBlackList" :items="[{value: 0,  text: 'Liberar cadastro'}, {value: 1, text:'Bloquear cadastro' }, {value: 2, text: 'Permitir apenas clientes reservados'}]"></v-select>
                    </v-col>
                  </v-row>

                  <v-divider></v-divider>


                  <v-row class="py-3">
                    <v-col class="d-flex align-center" cols="12" md="6">
                      <div class="d-flex flex-column">
                       
                        <v-card-subtitle class="title py-0 px-0">
                         Layout da tela de busca</v-card-subtitle>
                        <h5 class="grey--text">Escolha o layout apropriado para a tela de busca</h5>
                      </div>
                    </v-col>
                    <v-col class="d-flex align-center justify-end" cols="12" md="6">
                      <v-select v-model="formStore.options.specialTheme" :items="[{value: '',  text: 'Padrão (Filtros à esquerda, resultado de busca à direita)'}, {value: '--rounded-theme', text:'Vertical (Filtros horizontais acima, resulta de busca abaixo)' }]"></v-select>
                    </v-col>
                  </v-row>
                 <v-divider></v-divider>

                 <SwitchEditor :active-edit="true" :wip="false" title="Exibir carrinho na tela de busca"
                    subtitle="Selecione para exibir resumo do carrinho de compras na tela de busca"
                    active-text="Exibir" inactive-text="Não exibir (padrão)" :snap="formStore.options.summaryOnSearch" :reverse-value="false" @update-form="
    formStore.options.summaryOnSearch = $event
    "></SwitchEditor>

                  <v-divider></v-divider>


                  <SwitchEditor :title="$t('mainStore.privacy.title')"
                  :subtitle="$t('mainStore.privacy.subtitle')"
                  :active-text="$t('mainStore.privacy.allow')" :inactive-text="$t('mainStore.privacy.disallow')" :snap="formStore.options.policy_privacy" @update-form="
                  formStore.options.policy_privacy = $event
                  "></SwitchEditor>
                    <template v-if="!formStore.options.policy_privacy">
                      <StorePolicyVue v-if="formStore.companyInfo" :store-policy="formStore.companyInfo.policy_privacy"
                        @update:storePolicy="updateStorePolicy" />
                    </template>
                    <template v-else>
                      <TextEditor :reference="'privacy_policy'" :title="$t('mainStore.privacy.title')" :label="$t('mainStore.privacy.title')" :subtitle="$t('mainStore.privacy.subText')"></TextEditor>
                    </template>
                    <v-divider></v-divider>
                    <SwitchEditor :active-edit="true" :wip="true" :title="$t('mainStore.asusNeedQuotation.title')"
                      :subtitle="$t('mainStore.asusNeedQuotation.subtitle')"
                      :active-text="$t('mainStore.packagesView.allow')" :inactive-text="$t('mainStore.packagesView.disallow')
                        " :snap="formStore.options.asusNeedQuotation" :reverse-value="false"
                      @update-form="formStore.options.asusNeedQuotation = $event"></SwitchEditor>
                    <v-divider></v-divider>
  
  
                    <SwitchEditor :title="$t('mainStore.terms.title')"
                    :subtitle="$t('mainStore.terms.subtitle')"
                    :active-text="$t('mainStore.terms.allow')" :inactive-text="$t('mainStore.terms.disallow')" :snap="formStore.options.terms" @update-form="formStore.options.terms = $event"></SwitchEditor>
                      <template v-if="!formStore.options.terms">
                        <StoreTerms v-if="formStore.companyInfo" :store-terms="formStore.companyInfo.terms"
                        @update-form="formStore.companyInfo.terms = $event" />
                      </template>
                      <template v-else>
                        <TextEditor :reference="'comercial_terms'" :title="$t('mainStore.terms.title')" :label="$t('mainStore.terms.text')" :subtitle="$t('mainStore.terms.subText')"></TextEditor>
                      </template>
                    <!-- <v-divider></v-divider>

                  <StoreTerms v-if="formStore.companyInfo" :store-terms="formStore.companyInfo.terms"
                    @update-form="formStore.companyInfo.terms = $event" /> -->

                  <v-divider></v-divider>
                  <v-row class="py-3">
                    <v-col class="d-flex align-center" cols="12" md="12">
                      <v-card-subtitle class="title px-0">{{
                        $t("mainStore.aboutStore.footerTitle")
                      }}</v-card-subtitle>
                    </v-col>
                    <v-col class="d-flex" cols="12" md="6">
                      <v-card-text class="subtitle-1 font-weight-bold py-0">{{
                        $t("mainStore.aboutStore.footerText")
                      }}</v-card-text>
                    </v-col>
                    <v-col cols="12" md="6" class="" v-if="formStore && formStore.companyInfo">
                      <template v-if="readOnly">
                        <div class="d-flex justify-end">
                          
                          <span v-html="formStore.companyInfo.footerText"></span>
                          <v-btn icon @click="editFooter()">
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <template v-else>
                        <v-textarea height="50" dense v-if="formStore.companyInfo.footerText !== undefined" ref="textArea"
                          v-model="formStore.companyInfo.footerText"></v-textarea>
                        <v-btn icon @click="doneFooter()" color="success" v-if="readOnly == false">
                          <v-icon>mdi-check-circle-outline</v-icon>
                        </v-btn>
                        <v-btn icon color="info" @click="restartFooter" v-if="readOnly == false">
                          <v-icon>mdi-restart</v-icon>
                        </v-btn>
                      </template>
                    </v-col>
                  </v-row>
                  <v-row>

                    <v-col style="place-self: center" class="align-cente" cols="12" md="2">
                      <v-card-text readonly class="subtitle-1 font-weight-bold">{{ $t("mainStore.aboutStore.socialMidia")
                      }}
                      </v-card-text>
                    </v-col>
                    <v-col cols="12" md="5" v-if="formStore && formStore.companyInfo &&
                      formStore.companyInfo.socialMedia
                      ">
                      <div class="d-flex align-center">
                        <h5 class="mr-2">Facebook:</h5>
                        <v-text-field :readonly="formDisabled" v-model="formStore.companyInfo.socialMedia.facebook"
                          class="" :placeholder="this.formStore?.companyInfo?.socialMedia?.facebook
                            ? this.formStore?.companyInfo?.socialMedia
                              ?.facebook
                            : 'https://www.facebook.com/'
                            "></v-text-field>
                      </div>

                      <div class="d-flex align-center">
                        <h5 class="mr-2">Instagram:</h5>
                        <v-text-field :readonly="formDisabled" v-model="formStore.companyInfo.socialMedia.instagram"
                          class="" :placeholder="this.formStore?.companyInfo?.socialMedia?.instagram
                            ? this.formStore?.companyInfo?.socialMedia
                              ?.instagram
                            : 'https://www.instagram.com/'
                            "></v-text-field>
                      </div>
                      <div class="d-flex align-center">
                        <h5 class="mr-2">Tik Tok:</h5>
                        <v-text-field :readonly="formDisabled" v-model="formStore.companyInfo.socialMedia.tiktok"
                          class="" :placeholder="this.formStore?.companyInfo?.socialMedia?.tiktok
                            ? this.formStore?.companyInfo?.socialMedia
                              ?.tiktok
                            : 'https://www.tiktok.com/'
                            "></v-text-field>
                      </div>
                    </v-col>

                    <v-col cols="12" md="5" v-if="formStore.companyInfo && formStore.companyInfo.socialMedia">
                      <div class="d-flex align-center">
                        <h5 class="mr-2">Twitter:</h5>
                        <v-text-field :readonly="formDisabled" v-model="formStore.companyInfo.socialMedia.twitter"
                          class="" :placeholder="this.formStore?.companyInfo?.socialMedia?.twitter
                            ? this.formStore?.companyInfo?.socialMedia
                              ?.twitter
                            : 'https://www.twitter.com/'
                            "></v-text-field>
                        <v-btn icon @click="editMediaForm()">
                          <v-icon>mdi-pencil-outline</v-icon>
                        </v-btn>
                        <v-btn v-if="formDisabled == false" color="green" icon @click="editMediaForm()">
                          <v-icon>mdi-check-circle-outline</v-icon>
                        </v-btn>
                      </div>

                      <div class="d-flex align-center">
                        <h5 class="mr-2">YouTube:</h5>
                        <v-text-field :readonly="formDisabled" v-model="formStore.companyInfo.socialMedia.youtube"
                          class="" :placeholder="this.formStore?.companyInfo?.socialMedia?.youtube
                            ? this.formStore?.companyInfo?.socialMedia
                              ?.youtube
                            : 'https://www.youtube.com/'
                            "></v-text-field>
                      </div>
                      <div class="d-flex align-center">
                        <h5 class="mr-2">LikedIn:</h5>
                        <v-text-field :readonly="formDisabled" v-model="formStore.companyInfo.socialMedia.linkedin"
                          class="" :placeholder="this.formStore?.companyInfo?.socialMedia?.linkedin
                            ? this.formStore?.companyInfo?.socialMedia
                              ?.linkedin
                            : 'https://www.linkedin.com/'
                            "></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                     <SwitchEditor title="Exibir e-mail no rodapé"
                  subtitle="Você pode exibir o e-mail ou não exibir."
                  active-text="Exibir" inactive-text="Esconder" :snap="formStore.options.showEmail" @update-form="
                  formStore.options.showEmail = $event
                  "></SwitchEditor>
                  </v-row>
                    <v-row>
                      <v-text-field label="E-mail do rodapé" v-model="formStore.companyInfo.sacEmail"></v-text-field>
                    </v-row>
                    <v-row>
                      <SwitchEditor title="Exibir telefone no rodapé"
                      subtitle="Você pode exibir o telefone ou não exibir."
                      active-text="Exibir" inactive-text="Esconder" :snap="formStore.options.showPhone" @update-form="
                      formStore.options.showPhone = $event
                      "></SwitchEditor>
                    </v-row>
                    <v-row v-if="formStore.options.showPhone">
                      <v-text-field label="Número de telefone" v-model="formStore.companyInfo.phone"></v-text-field>
                    </v-row>
<v-row>
  <SwitchEditor title="Utilizar chat de atendimento por WhatsApp"
  subtitle="Você pode exibir o link do chat por WhatsApp ou incluir um código de chat customizado"
  active-text="Sim" inactive-text="Não, outro aplicativo" :snap="formStore.options.isWhatsapp" @update-form="
  formStore.options.isWhatsapp = $event
  "></SwitchEditor>
</v-row>

<v-row>
                  <v-textarea v-if="!formStore.options.isWhatsapp" label="Código Customizado" v-model="formStore.companyInfo.customScript"></v-textarea>
                      <v-text-field v-else label="Número do WhatsApp" v-model="formStore.companyInfo.whatsApp"></v-text-field>
                  </v-row>
                  <v-divider></v-divider>

                  <!-- DESCRIPTION SECTION -->

                  <!-- <StoreDescriptionVue
                    :store-descript="formStore.advantage"
                    @update:storeDescript="updateStoreDescript"
                  />

                  <v-divider></v-divider> -->

                  <!-- GENDER SECTION -->

                  <SwitchEditor :active-text="$t('mainStore.packagesView.allow')" :inactive-text="$t('mainStore.packagesView.disallow')
                    " :snap="formStore.options.hideGenderGraph" :reverse-value="true" @update-form="
    formStore.options.hideGenderGraph = $event
    "></SwitchEditor>
                  <GenderSecVue :storeGender="formStore.info.audience.gender" @update:storeGender="updateStoreGender" />

                  <v-divider></v-divider>

                  <!-- Age Group SECTION -->
                  <SwitchEditor :active-text="$t('mainStore.packagesView.allow')" :inactive-text="$t('mainStore.packagesView.disallow')
                    " :snap="formStore.options.hideAgegroupGraph" :reverse-value="true" @update-form="
    formStore.options.hideAgegroupGraph = $event
    "></SwitchEditor>
                  <v-row class="py-6" v-if="formStore.info && formStore.info.audience">
                    <v-col class="d-flex align-center" cols="12" md="6">
                      <v-card-subtitle class="title px-0">{{
                        $t("mainStore.aboutStore.ageGroup.title")
                      }}</v-card-subtitle>
                    </v-col>

                    <v-col class="" cols="12" md="6">
                      <AudienceAgeGroup :groups="formStore.info.audience.ageGroup" @update-store="
                        formStore.info.audience.ageGroup = $event
                        " />
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>

                  <!-- Social Class SECTION -->
                  <SwitchEditor :active-text="$t('mainStore.packagesView.allow')" :inactive-text="$t('mainStore.packagesView.disallow')
                    " :snap="formStore.options.hideSocialGraph" :reverse-value="true" @update-form="
    formStore.options.hideSocialGraph = $event
    "></SwitchEditor>
                  <v-row class="py-6" v-if="formStore.info && formStore.info.audience">
                    <v-col class="d-flex align-center" cols="12" md="6">
                      <v-card-subtitle class="title px-0">{{
                        $t("mainStore.aboutStore.SL.title")
                      }}</v-card-subtitle>
                    </v-col>
                    <v-col class="" cols="12" md="6">
                      <AudienceSocialClass :snap="formStore.info.audience.socialClass" @update-store="
                        formStore.info.audience.socialClass = $event
                        " /><!-- -->
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <SwitchEditor :active-text="$t('mainStore.packagesView.allow')" :inactive-text="$t('mainStore.packagesView.disallow')
                    " :snap="formStore.options.hideCustomAudience" :reverse-value="true" @update-form="
    formStore.options.hideCustomAudience = $event
    "></SwitchEditor>
                  <GeneralGraphVue :snap="formStore.info.audience.customAudience" @update-store=" formStore.info.audience.customAudience = $event
                    " />

                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat outlined class="mt-9 px-6">
                  <div class="py-6">
                    <BannersSection></BannersSection>
                  </div>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                  <!-- DISCLAIMER -->

                  <div class="py-6">
                    <DisclaimerSection @update-store="formStore.disclaimers = $event" :documents="formStore.disclaimers">
                    </DisclaimerSection>
                  </div>

                  <v-divider></v-divider>
                  <div class="py-6">
                    <ColorsSection @update-store="formStore.config = $event" :snap="formStore.config"
                      :logo="selectedStore.logo"></ColorsSection>
                  </div>

                  <v-divider></v-divider>

                  <div class="py-6">
                    <PositionsSection @update-store="formStore.sortSections = $event" :snap="formStore.sortSections">
                    </PositionsSection>
                  </div>
                  <v-divider></v-divider>

                  <div class="py-6">
                    <SearchSection @update-store="formStore.searchSection = $event" :snap="formStore.searchSection">
                    </SearchSection>
                  </div>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <AbousUsSection @update-store="formStore.info.about = $event" :snap="formStore.info.about">
                </AbousUsSection>
              </v-tab-item>
              <v-tab-item>
                <FaqSection>
                </FaqSection>
              </v-tab-item>

            </v-tabs-items>
          </v-card>
        </template>
      </v-col>
    </v-row>


    <v-btn v-if="editing" :loading="processing" width="500" class="white--text title py-6 my-6" style="
        position: fixed;
        left: 50%;
        margin-left: -250px;
        top: calc(100vh - 100px);
        z-index: 100;
      " color="primary" @click="save(formStore)">{{ $t("mainStore.defaultBtn") }}</v-btn>
    <!-- <v-snackbar
      color="success"
      style="top: 70px"
      top
      :timeout="5000"
      v-model="sucessSaved"
    >
      {{ $t("mainStore.personalize.storeSaved") }}

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          size="26"
          color="white"
          v-bind="attrs"
          @click="sucessSaved = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar> -->
    <v-dialog v-model="confirm.show" width="640">
      <v-card class="mx-auto">
        <v-card-title>{{ $t('mainStore.confirm.title') }}</v-card-title>
        <v-card-text>
          <div v-if="confirm.newStatus == 'published'">{{ $t('mainStore.confirm.text') }}</div>
          <div v-else>
            {{ $t('mainStore.confirm.disabled') }}

            <v-radio-group v-model="confirm.newStatus">
              <v-radio :label="$t('mainStore.confirm.yes')" value="disabled"></v-radio>
              <v-radio :label="$t('mainStore.confirm.no')" value="review"></v-radio>
            </v-radio-group>
          </div>
          <v-text-field outlined class="mt-3" v-model="confirm.text"
            :label="$t('mainStore.confirm.type', { text: confirmTextC })"></v-text-field>
          <div class="pt-3 d-flex">
            <v-spacer></v-spacer>
            <v-btn text @click="cancel()">{{ $t('common.cancel') }}</v-btn>
            <v-btn color="success" elevation="0" @click="confirmUpdateStatus()"
              :disabled="confirm.text != $t('common.ok').toUpperCase()">{{ $t('common.save') }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import GeneralGraphVue from "@/components/mainStore/GeneralGraph.vue";
import { mapGetters, mapActions, mapState } from "vuex";
import GenderSecVue from "@/components/mainStore/GenderSec.vue";
import StoreURLVue from "@/components/mainStore/StoreURL.vue";
//import PriceView from "@/components/mainStore/PriceView.vue";
import StorePolicyVue from "@/components/mainStore/StorePolicy.vue";
import StoreNameVue from "@/components/mainStore/StoreName.vue";
import config from "@/store/config";
import moment from "moment";
import AudienceAgeGroup from "@/components/customize/AudienceAgeGroup.vue";
import Upload from "@/interface/FireUpload.vue";
import BannersSection from "@/components/customize/BannersSection.vue";
import DisclaimerSection from "@/components/customize/DisclaimerSection.vue";
// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";

import ColorsSection from "@/components/customize/ColorsSection.vue";
import PositionsSection from "@/components/customize/PositionsSection.vue";
import SearchSection from "@/components/customize/SearchSection.vue"
import AudienceSocialClass from "@/components/customize/AudienceSocialClass.vue";
import AbousUsSection from "@/components/customize/AbousUsSection.vue";
import FaqSection from "@/components/customize/FaqSection.vue";
import StoreTerms from "@/components/mainStore/StoreTerms.vue";

import SwitchEditor from "@/components/mainStore/SwitchEditor.vue";
import TextEditor from "@/components/mainStore/TextEditor.vue"
export default {
  name: "MainStore",
  components: {
    //PriceView,
    AudienceAgeGroup,
    Upload,
    BannersSection,
    DisclaimerSection,
    ColorsSection,
    PositionsSection,
    AudienceSocialClass,
    AbousUsSection,
    FaqSection,
    StoreNameVue,
    StoreURLVue,
    StorePolicyVue,
    SearchSection,
    GenderSecVue,
    StoreTerms,
    SwitchEditor,
    GeneralGraphVue,
    TextEditor
  },
  data() {
    return {
      restrictText: "",
      confirm: {
        newStatus: null,
        text: "",
        show: false,
        update: 0
      },
      lockChange: false,
      readyToEdit: false,
      processing: false,
      editing: false,
      defaultBtn: false,
      sucessSaved: false,
      form: {},

      snapStore: {},

      formStore: {},

      formDisabled: true,
      readOnlyTextArea: true,
      readOnly: true,
      tabs: null,
      over: {},
      startLoc: 0,

      menuBar: [
        { title: this.$t("mainStore.aboutStore.stepTitle"), enabled: true },
        { title: this.$t("mainStore.personalize.stepTitle"), enabled: true },
        { title: this.$t("mainStore.personalize.aboutUs.title"), enabled: true },
        { title: 'FAQ', enabled: true }
        //{ title: this.$t("mainStore.Mkt&SEO.stepTitle"), enabled: false },
        // { title: this.$t('mainStore.cupons.stepTitle'), enabled: false },
        // { title: "Descuentos" },
      ],
      updated: 0,
    };
  },

  computed: {
    ...mapState("groupStores", [
      "allStores",
      "masterStore",
      "subStores",
      "selectedStore",
    ]),
    confirmTextC() {
      return this.$t('common.ok').toUpperCase()
    },
    statusForm() {
      return this.formStore.status == 'published' ? true : false
    },
    statusFormText() {
      return this.$t(`mainStore.status.${this.formStore.status}`);
    }
  },
  mounted() {
    this.loadTabs();
    this.loadStore()
  },
  watch: {
    formStore: {
      deep: true,
      handler(val, oldVal) {
        console.log("CHANGE FORM STORE!", val);
        console.log("old snap is", oldVal);

        console.log("lock change ?", this.lockChange);
        if (this.readyToEdit && !this.lockChange) this.editing = true;
      },
    },

    tabs: {
      immediate: true,
      handler(nV) {
        console.log("change tab to", nV);
        if (nV == 0 && !this.$route.params.hasOwnProperty("tab")) {
          if(this.$route.fullPath != '/settings')
          this.$router.replace(`/settings`);
        }

        if (nV == 1 && this.$route.params.tab != "layout") {
          this.$router.replace(`/settings/layout`);
        }
        if (nV == 2 && this.$route.params.tab != "about-us") {
          this.$router.replace(`/settings/about-us`);
        }
        if (nV == 3 && this.$route.params.tab != "faq") {
          this.$router.replace(`/settings/faq`);
        }
      },
    },
  },

  methods: {
    loadStore() {
      if (this.selectedStore) {
        console.log('selectedStore', this.selectedStore && this.selectedStore.length)
        this.cloneStore();
      }
      else {
        setTimeout(() => {
          this.loadStore()
        }, 300)
      }
    },
    confirmUpdateStatus() {
      this.formStore.status = this.confirm.newStatus
      this.confirm.newStatus = null
      this.confirm.text = ""
      this.confirm.show = false
    },
    cancel() {
      this.confirm.update++
      this.confirm.newStatus = null
      this.confirm.text = ""
      this.confirm.show = false
    },
    saveStatus(e) {
      // if(e != 'published'){
      if (e == true) {
        this.confirm.newStatus = 'published'
      }
      else {
        this.confirm.newStatus = e
      }
      this.confirm.show = true
      // }
    },
    loadTabs() {
      console.log("this.$route.params", this.$route.params);
      if (
        !this.$route.params.hasOwnProperty("tab") ||
        !this.$route.params.tab
      ) {
        this.tabs = 0;
      } else {
        switch(this.$route.params.tab){
          case 'configurations':
            this.tabs = 0
            break;
            case 'layout':
            this.tabs = 1
            break;
            case 'about-us':
            this.tabs = 2
            break;
            case 'faq':
            this.tabs = 3
            break;
        }
      }
    },
    save(form) {
      this.processing = true;
      this.saveStore(form).then(
        () => {
          this.editing = false;
          this.processing = false;

          //this.sucessSaved = true;
        },
        (err) => {
          console.error("err", err);
        }
      ).then(() => {
        this.showSnack({
          text: this.$t("mainStore.personalize.storeSaved"),
          color: "success",
          timeout: 3800,
          icon: "mdi-check",
        });
      });
    },
    cloneStore() {
      this.readyToEdit = false;

      let test = JSON.parse(JSON.stringify(this.selectedStore));
      if (!test.hasOwnProperty("options")) {
        test.options = {};
      }

      if (!test.options.hasOwnProperty("hideAsus")) {
        test.options.hideAsus = false;
      }
      if (!test.options.hasOwnProperty("includeTax")) {
        test.options.includeTax = false
      }

       if (!test.options.hasOwnProperty("isWhatsapp")) {
          test.options.isWhatsapp = true
       }
       if (!test.options.hasOwnProperty("showEmail")) {
          test.options.showEmail = true
      }
       if (!test.options.hasOwnProperty("showPhone")) {
        test.options.showPhone = true
      }
      if (!test.companyInfo.hasOwnProperty("customScript")) {
        test.companyInfo.customScript = ""
      }
     

      if (!test.options.hasOwnProperty("policy_privacy")) {
        test.options.policy_privacy = false
      }
      if (!test.options.hasOwnProperty("hidePackages")) {
        test.options.hidePackages = false;
      }
      if (!test.options.hasOwnProperty("hidePackagesCPM")) {
        test.options.hidePackagesCPM = false;
      }
      if (!test.options.hasOwnProperty("homeSessions")) {
        test.options.homeSessions = true;
      }
      if (!test.options.hasOwnProperty("hidePlacementHelper")) {
        test.options.hidePlacementHelper = false;
      }
      if (!test.options.hasOwnProperty("hideLocations")) {
        test.options.hideLocations = false;
      }
      if (!test.options.hasOwnProperty("hideCoverage")) {
        test.options.hideCoverage = false;
      }
      if(!test.options.hasOwnProperty('useBlackList')){
        test.options.useBlackList = 0
      }
      if (!test.hasOwnProperty("searchSection")) {
        test.searchSection = [
          {
            id: 'locations',
            active: true,
          },
          {
            id: 'mediaType',
            active: true,
          },
          {
            id: 'category',
            active: true,
          },
          {
            id: 'format',
            active: true,
          },
          {
            id: 'buckets',
            active: true,
          },
          {
            id: 'interests',
            active: true,
          },
          {
            id: 'ageGroup',
            active: true,
          },
          {
            id: 'gender',
            active: true,
          },
          {
            id: 'socialClass',
            active: true,
          },{
            id: 'sessions',
            active: true,
          },

        ]
      }
      if (!test.options.hasOwnProperty("packageNeedQuotation")) {
        test.options.packageNeedQuotation = false;
      }
      if (!test.options.hasOwnProperty('restrictAccessToWhitelist')) {
        test.options.restrictAccessToWhitelist = false
      }
      if (!test.options.hasOwnProperty('restrictAccessText')) {
        test.options.restrictAccessText = ''
      }
      if (!test.options.hasOwnProperty('noContent')) {
        test.options.noContent = false
      }
      if (!test.options.hasOwnProperty("asusNeedQuotation")) {
        test.options.asusNeedQuotation = false;
      }
      if(!test.options.hasOwnProperty('summaryOnSearch')){
        test.options.summaryOnSearch = false
      }
      if(!test.options.hasOwnProperty('slidesFullWidth')){
        test.options.slidesFullWidth = false
      }

      
      if(!test.options.hasOwnProperty('specialTheme')){
        test.options.specialTheme = ""
      }

      this.$set(this, "formStore", test);
      setTimeout(() => {
        this.readyToEdit = true;
      }, 200);
    },

    ...mapActions("groupStores", ["setValueInStore", "saveStore"]),
    ...mapActions("snackbar", ["showSnack"]),

    updateStoreName(newName) {
      this.formStore.name = newName;
    },
    updateStoreURL(urlName) {
      this.formStore.redirectURL = urlName;
    },
    updatePriceView(value) {
      if (!this.formStore.hasOwnProperty("options")) {
        this.formStore.options = {};
      }
      this.formStore.options.priceView = value


      this.formStore.options.priceView = value;
    },
    updateStorePolicy(plink) {
      this.formStore.companyInfo.policy_privacy = plink;
    },
    updateStoreDescript(descript) {
      this.formStore.advantage = descript;
    },
    updateStoreGender(gender) {
      this.formStore.info.audience.gender = gender;
    },

    editFooter() {
      this.readOnly = !this.readOnly;
    },

    editMediaForm() {
      this.formDisabled = !this.formDisabled;
    },

    doneFooter() {
      this.readOnly = true;
    },

    restartFooter() {
      this.formStore.companyInfo.editFooter =
        this.formStore.companyInfo.editFooter;
      this.readOnly = !this.readOnly;
    },
  },
};
</script>

<style lang="scss" scoped>
.list>div {
  display: flex;
  flex-direction: column;
}

.item {
  width: 600px;
  border: 1px solid;
  padding: 10px;
  margin: 10px auto 10px 10px;
  background: white;
  color: black;
  font-family: sans-serif;
  border-radius: 5px;
  display: inline-block;
  /*   transition: opacity .3s ease-in-out; */
}

.flip-list-move {
  transition: transform 0.2s;
}

.over {
  opacity: 0.6;
}

.down {
  /*   transform: translateY(-20px); */
}

.up {
  /*    transform: translateY(20px); */
}
</style>
